export default __webpack_public_path__ + "static/media/generic.0663c5e3.svg";